export const GOAL_AD_COST: Record<
  CreateCampaignObjectiveBasedFormData['goal'],
  { min: number; max: number }
> = {
  profitability: {
    min: 5,
    max: 15
  },
  growth: {
    min: 15,
    max: 30
  },
  reach: {
    min: 30,
    max: 50
  }
}

export const MIN_CAMPAIGN_PERIOD_WEEKS = 3
export const MIN_CAMPAIGN_PERIOD_DAYS = MIN_CAMPAIGN_PERIOD_WEEKS * 7
export const MIN_RECOMMENDED_PRODUCTS = 10
export const MAX_RECOMMENDED_PRODUCTS = 20
